import { BREAKPOINTS } from '@/utils/responsive';

const GlobalStyles = () => {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
        :root {
          /* Legacy color aliases - reference main design tokens from index.css */
          --medical-blue: var(--brand-medical-blue);
          --medical-green: var(--brand-medical-green);
          --trust-gray: var(--brand-trust-gray);
          --accent-blue: var(--brand-accent-blue);
          --light-blue: var(--brand-light-blue);
          --safe-area-inset-top: env(safe-area-inset-top, 0px);
          --safe-area-inset-right: env(safe-area-inset-right, 0px);
          --safe-area-inset-bottom: env(safe-area-inset-bottom, 0px);
          --safe-area-inset-left: env(safe-area-inset-left, 0px);
        }

        /* Global typography */
        * {
          font-family: 'Inter', 'Montserrat', 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        body {
          font-feature-settings: "kern" 1, "liga" 1, "calt" 1;
          text-rendering: optimizeLegibility;
        }

        h1, h2, h3, h4, h5, h6 {
          letter-spacing: var(--letter-spacing-tight);
          font-weight: var(--font-weight-semibold);
        }

        p, span, div, li, label {
          letter-spacing: var(--letter-spacing-normal);
        }

        /* Safe area utilities for notched devices */
        .pt-safe { padding-top: var(--safe-area-inset-top); }
        .pr-safe { padding-right: var(--safe-area-inset-right); }
        .pb-safe { padding-bottom: var(--safe-area-inset-bottom); }
        .pl-safe { padding-left: var(--safe-area-inset-left); }

        /* Fixed-position helper that respects bottom safe area on all breakpoints */
        .fixed-safe-bottom {
          bottom: calc(1.5rem + var(--safe-area-inset-bottom));
        }
        @media (min-width: ${BREAKPOINTS.sm}px) {
          .fixed-safe-bottom {
            bottom: calc(2rem + var(--safe-area-inset-bottom));
          }
        }
        @media (min-width: ${BREAKPOINTS.lg}px) {
          .fixed-safe-bottom {
            bottom: calc(2.5rem + var(--safe-area-inset-bottom));
          }
        }
      `,
      }}
    />
  );
};

export default GlobalStyles;
